<template>
  <CModal
    @mtdclosemodal="mtdclosemodal"
    :show="boo_modal"
    :close-on-backdrop="false"
    :centered="true"
    :title="title"
    :size="modalSize"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <div class="row">
      <div class="col-md-3 col-lg-3">
        <label for="brand" class="mb-3 mt-2">Marca</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fas fa-copyright"></i>
            </span>
          </div>
          <v-select
            @input="mtdbrandadd"
            id="brand"
            class="text-dark form-control"
            label="name"
            :options="dataMarca"
            placeholder="- Buscar Marca -"
            @search="searchmarca"
            v-model="Subsubcategory.brand"
            :reduce="(name) => name.id"
            required
            :clearable="false"
          >
            <template slot=" no-options">
              No hay Productos para la busqueda.
            </template>
          </v-select>
          <div class="ms-1 p-1 h-100">
            <button
              class="btn btn-success btn-sm text-xxs me-1"
              title="Agregar Marca"
              @click="mtdAddBrand()"
            >
              <i class="fas fa-plus text-white"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-9 col-lg-9">
        <label for="brand" class="mb-3 mt-2">Proveedor</label>
        <div class="input-group input-group-sm">
          <div class="input-group-text">
            <span style="font-size: 20px; border: none">
              <i class="fas fa-copyright"></i>
            </span>
          </div>
          <v-select
            @input="mtdproviderdadd"
            id="brand"
            class="text-dark form-control"
            label="name"
            :options="dataProvider"
            placeholder="- Buscar Proveedores -"
            @search="searchprovider"
            v-model="Subsubcategory.provider"
            :reduce="(name) => name.id"
            required
            :clearable="false"
          >
            <template slot=" no-options">
              No hay Productos para la busqueda.
            </template>
          </v-select>
        </div>
      </div>
      <div class="col-md-6 col-lg-6">
        <label for="brand" class="mb-3 mt-2">Nombre Comercial</label>
        <input
          type="text"
          class="form-control"
          v-model="Subsubcategory.comercial"
          placeholder="Nombre comercial"
        />
      </div>
      <div class="col-md-6 col-lg-6">
        <label for="brand" class="mb-3 mt-2">Precio Venta</label>
        <input
          type="number"
          class="form-control"
          v-model="Subsubcategory.price"
          placeholder=""
        />
      </div>
    </div>
    <template #footer>
      <button
        class="btn btn-success btn-sm"
        @click="mtdInsertData"
        :disabled="cpButtonForm"
      >
        <i class="fas fa-save" />&nbsp;Registrar
      </button>
      &nbsp;
    </template>
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </CModal>
</template>

<script>
import CModal from "@/components/shared/modals/CModal.vue";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import { mapActions } from "vuex";

export default {
  name: "c-medico-modal-diagnostico",

  data() {
    return {
      swal: null,
      Subsubcategory: {
        productDetailId: 0,
        brand: null,
        provider: null,
        comercial: "",
        price:0,
        tipo: "mantenimiento",
      },
      windowWidth: window.innerWidth,
      dataProvider: [],
      dataMarca: [],
    };
  },
  components: {
    CModal,
    SweetAlert,
  },
  computed: {
    modalSize() {
      return this.windowWidth >= 992 ? "xl" : "md";
    },
    cpButtonForm() {
      if (
        this.Subsubcategory.brand != null &&
        this.Subsubcategory.provider != null &&
        this.Subsubcategory.comercial.length > 0 &&
        this.Subsubcategory.price > 0
      )
        return false;
      return true;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  props: {
    title: String,
    boo_modal: Boolean,
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  methods: {
    ...mapActions(["get", "post"]),
    mtdclosemodal() {
        this.Subsubcategory = {
            productDetailId: 0,
            brand: null,
            provider: null,
            comercial: "",
            price:0
        };
      this.$emit("closeModalAddMedicament");
      // closeModal
      // closeModalAddMedicament
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    searchmarca: function (search, loading) {
      if (search.length >= 2) {
        this.dataMarca = [];
        loading(true);
        this.get({
          url: this.$store.getters.get__url + "/logistics/indexbrand/" + search,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            this.dataMarca = response.data;
            loading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    mtdbrandadd() {
      this.Subsubcategory.brand_id = this.Subsubcategory.brand;
    },
    mtdAddBrand: function () {
      this.$emit("mtdAddBrand");
    },
    searchprovider: function (search, loading) {
      if (search.length >= 2) {
        this.dataProvider = [];
        loading(true);
        this.get({
          url:
            this.$store.getters.get__url + "/logistics/indexprovider/" + search,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            this.dataProvider = response.data;
            loading(false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    mtdproviderdadd: function () {
      this.Subsubcategory.provider = this.Subsubcategory.provider;
    },
    mtdInsertData: function () {
      this.Subsubcategory.productDetailId = this.payload.id;
      console.log(this.Subsubcategory);
      this.post({
        url: this.$store.getters.get__url + "/logistics/oc/storemedicine",
        token: this.$store.getters.get__token,
        params: this.Subsubcategory,
      })
        .then((response) => {
          if (response.statusCode == 200) {
            this.mtdclosemodal();
            this.$emit("storemedicine");
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },
  },
};
</script>
